import BaseChartMore from '../baseChartMore';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Series Data array for bubble chart */
//   data: [],
//   /* Set additional options for bubble chart. */
//   options: {},
//   /* Theme of the bubble chart. */
//   theme: string,
// };

export default function Bubble(props) {
  const { className, data, options, ...otherProps } = props;

  const defaultOptions = {
    xAxis: {
      gridLineWidth: 1,
    },
    yAxis: {
      title: {
        text: '',
      },
      startOnTick: false,
      endOnTick: false,
      gridLineWidth: 1,
    },
    exporting: {
      enabled: false,
    },
  };

  return (
    <BaseChartMore
      className={className}
      chartType="bubble"
      data={data}
      defaultOptions={defaultOptions}
      options={options}
      {...otherProps}
    />
  );
}
